var _rect, _rect2, _path, _path2, _ellipse, _ellipse2, _ellipse3, _ellipse4, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect3, _path10, _rect4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPnc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 69,
    viewBox: "0 0 68 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.695312,
    width: 68,
    height: 68,
    rx: 16,
    fill: "#F7F9FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 20.5,
    y: 44.6953,
    width: 31,
    height: 16,
    rx: 4,
    fill: "#37435A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2773 52.8066C34.2773 55.3472 32.7036 56.8027 30.6465 56.8027C28.5732 56.8027 27.0049 55.3364 27.0049 52.8066C27.0049 50.2661 28.5732 48.8105 30.6465 48.8105C32.7036 48.8105 34.2773 50.2661 34.2773 52.8066ZM28.6484 52.8066C28.6484 54.4663 29.438 55.3687 30.6465 55.374C31.8442 55.3687 32.6392 54.4663 32.6338 52.8066C32.6392 51.1416 31.8442 50.2446 30.6465 50.2393C29.438 50.2446 28.6484 51.1416 28.6484 52.8066ZM35.4375 56.6953V48.918H37.0488V52.3662H37.1562L39.9814 48.918H41.9258L39.0254 52.3984L41.958 56.6953H40.0244L37.8652 53.4834L37.0488 54.4717V56.6953H35.4375ZM44.5898 48.918L44.4502 54.3643H43.0752L42.9355 48.918H44.5898ZM42.8711 55.8896C42.8604 55.3955 43.2686 54.9927 43.7734 54.998C44.2515 54.9927 44.665 55.3955 44.665 55.8896C44.665 56.3892 44.2515 56.792 43.7734 56.792C43.2686 56.792 42.8604 56.3892 42.8711 55.8896Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8203 24.1112C29.8203 17.4082 34.8656 11.7797 41.5286 11.0493L47.6602 10.3771C55.8483 9.4795 63.0019 15.8917 63.0019 24.1288C63.0019 32.3975 55.7961 38.8196 47.5819 37.8718L41.4542 37.1647C34.8238 36.3996 29.8203 30.7855 29.8203 24.1112Z",
    fill: "url(#paint0_radial_18875_203163)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.3,
    cx: 44.4426,
    cy: 24.1753,
    rx: 6.45659,
    ry: 8.12235,
    transform: "rotate(19.2416 44.4426 24.1753)",
    fill: "#D9D9D9"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.4426,
    cy: 24.1753,
    rx: 6.45659,
    ry: 8.12235,
    transform: "rotate(19.2416 44.4426 24.1753)",
    fill: "#D9D9D9"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.4426,
    cy: 24.1753,
    rx: 6.45659,
    ry: 8.12235,
    transform: "rotate(19.2416 44.4426 24.1753)",
    fill: "#4A5256"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18875_203163",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 16,
    width: 14,
    height: 17
  }, _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.1106,
    cy: 24.9448,
    rx: 6.45659,
    ry: 8.12235,
    transform: "rotate(19.2416 48.1106 24.9448)",
    fill: "#111924"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18875_203163)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 44.4426,
    cy: 24.1753,
    rx: 6.45659,
    ry: 8.12235,
    transform: "rotate(19.2416 44.4426 24.1753)",
    fill: "#222729"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1523 22.4492L48.3465 22.9709C48.3465 22.9709 48.7039 23.5199 48.4913 24.8215C48.2787 26.1231 47.7652 26.5298 47.7652 26.5298L44.5711 26.0081C44.5711 26.0081 45.088 25.5802 45.2972 24.2998C45.5063 23.0194 45.1523 22.4492 45.1523 22.4492Z",
    fill: "url(#paint1_linear_18875_203163)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5703 26.0059L47.4256 26.4722C47.4256 26.4722 47.7526 26.9167 47.5831 27.9544C47.4136 28.9922 46.9621 29.3095 46.9621 29.3095L44.1069 28.8432C44.1069 28.8432 44.5611 28.5089 44.7278 27.4881C44.8946 26.4673 44.5703 26.0059 44.5703 26.0059Z",
    fill: "url(#paint2_linear_18875_203163)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8789 22.2402L47.0731 22.7619C47.0731 22.7619 47.3562 23.7655 46.9413 26.3057C46.5265 28.8458 45.9387 29.7072 45.9387 29.7072L42.7446 29.1855C42.7446 29.1855 43.3391 28.2827 43.7472 25.784C44.1553 23.2853 43.8789 22.2402 43.8789 22.2402Z",
    fill: "url(#paint3_linear_18875_203163)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5978 19.7577C47.4629 19.4876 44.9582 19.4432 43.7227 19.4548C43.9923 20.0208 44.0596 22.0944 44.0595 23.0605L46.8565 22.5887C47.1598 21.7576 47.7326 20.0277 47.5978 19.7577Z",
    fill: "#CEDBE2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8419 19.0816C28.9579 20.22 21.9436 27.2088 18.7969 30.561L22.2407 35.4029C22.3983 35.4292 22.816 35.466 23.2258 35.4029C23.738 35.3241 26.4173 33.748 26.7719 33.4328C27.1265 33.1176 26.7325 32.0144 27.2448 31.6597C27.757 31.3051 28.8208 32.0144 29.2148 32.0144C29.6089 32.0144 32.2094 30.1231 33.4308 29.4532C34.4351 28.9025 35.2542 28.8398 36.7275 28.9485C39.5478 29.1566 38.5925 30.2019 39.8927 30.561C41.3791 30.7192 42.8088 30.9407 43.4159 30.561C44.1749 30.0862 44.7441 20.9342 43.8903 19.511C43.0365 18.0878 35.4468 17.6587 31.8419 19.0816Z",
    fill: "#353C3F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4408 33.1701C19.8378 33.4686 19.9176 34.0323 19.6192 34.4292L18.9215 33.9047C19.6192 34.4292 19.6188 34.4297 19.6185 34.4301L19.6178 34.4311L19.6162 34.4331L19.6127 34.4377L19.6037 34.4493C19.5969 34.458 19.5885 34.4686 19.5783 34.4811C19.5579 34.506 19.5307 34.5383 19.4963 34.577C19.4275 34.6544 19.33 34.7573 19.2013 34.878C18.9437 35.1194 18.5615 35.4317 18.035 35.7523C16.978 36.3959 15.3593 37.0609 13.0361 37.2693C10.6336 37.4848 8.78925 36.8222 7.54382 36.0948C6.92397 35.7328 6.45354 35.3556 6.13406 35.0643C5.97407 34.9184 5.85112 34.7933 5.76539 34.7013C5.72249 34.6552 5.68883 34.6174 5.66442 34.5892C5.65221 34.5751 5.64231 34.5634 5.63471 34.5544L5.62505 34.5428L5.62152 34.5384L5.62007 34.5367L5.61943 34.5359C5.61914 34.5355 5.61885 34.5352 6.31738 33.9689L5.61885 34.5352C5.30613 34.1494 5.36537 33.5831 5.75116 33.2704C6.13581 32.9586 6.69985 33.0166 7.01314 33.3993C7.01268 33.3988 7.01265 33.3987 7.01303 33.3992L7.01332 33.3995L7.01408 33.4005L7.0149 33.4015L7.01538 33.4021C7.01564 33.4024 7.01591 33.4027 6.33151 33.9575L7.01592 33.4027C7.01499 33.4016 7.01407 33.4004 7.01314 33.3993M7.01332 33.3995C7.01458 33.401 7.01794 33.405 7.0234 33.4113C7.03434 33.4239 7.05365 33.4458 7.08128 33.4754C7.13661 33.5348 7.22492 33.6252 7.34578 33.7354C7.58798 33.9562 7.95752 34.2537 8.45086 34.5419C9.43181 35.1149 10.9067 35.6547 12.8754 35.4781C14.9235 35.2944 16.2773 34.717 17.0997 34.2162C17.513 33.9646 17.7973 33.7291 17.9713 33.566C18.0584 33.4843 18.118 33.4207 18.1523 33.3821C18.1695 33.3627 18.1803 33.3497 18.1852 33.3438C18.1861 33.3426 18.1868 33.3418 18.1873 33.3412C18.4871 32.9506 19.0463 32.8735 19.4408 33.1701",
    fill: "url(#paint4_linear_18875_203163)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8419 19.0816C28.9579 20.22 21.9436 27.2088 18.7969 30.561L20.5188 32.9819C24.0781 30.4477 31.7214 25.1005 33.8195 23.9858C35.9176 22.8712 41.6681 24.1239 44.2811 24.8895C44.3774 22.5251 44.289 20.1755 43.8903 19.511C43.0365 18.0878 35.4468 17.6587 31.8419 19.0816Z",
    fill: "#CEDBE2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 33.25,
    y: 17.9277,
    width: 6.2181,
    height: 1.05298,
    rx: 0.526489,
    fill: "#353C3F"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3575 32.4553C18.019 31.7967 19.1136 31.8895 19.6548 32.6501L20.6065 33.9877C21.1477 34.7483 20.8765 35.8128 20.0374 36.2219C19.3733 36.5457 18.5724 36.3417 18.1441 35.7397L17.1924 34.4021C16.7641 33.8001 16.8339 32.9766 17.3575 32.4553Z",
    fill: "#353C3F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 18.5352,
    y: 30.0039,
    width: 7.24124,
    height: 1.0788,
    rx: 0.5394,
    transform: "rotate(54.5684 18.5352 30.0039)",
    fill: "#353C3F"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_18875_203163",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.4111 24.1732) scale(16.5909 17.7838)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDD3DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A9DA7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18875_203163",
    x1: 46.9671,
    y1: 22.7456,
    x2: 50.2388,
    y2: 25.1994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#353C3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474522,
    stopColor: "#474E51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60676A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_18875_203163",
    x1: 46.1925,
    y1: 26.2708,
    x2: 48.9328,
    y2: 28.5415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#353C3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474522,
    stopColor: "#474E51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60676A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_18875_203163",
    x1: 45.6937,
    y1: 22.5366,
    x2: 49.7572,
    y2: 24.3687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#353C3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474522,
    stopColor: "#474E51"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60676A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_18875_203163",
    x1: 12.4744,
    y1: 35.7522,
    x2: 7.34222,
    y2: 34.277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#353C3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#353C3F",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPnc);
export default __webpack_public_path__ + "static/media/pnc.30a3102fae7c100472779565efc98c75.svg";
export { ForwardRef as ReactComponent };